import { produce } from 'immer';
import { create } from 'zustand';

type Env = 'none' | 'digitCreate' | 'digitDelete' | 'screenRatio';

interface EnvCtxType {
  envCtx: Env[];
  setEnvCtx: (e: Env) => void;
  exitEnvCtx: (e: Env) => void;
  getEnvCtx: () => Env;
  clearEnvCtx: () => void;
}

// 用于判断操作（例如快捷键）所处的上下文环境
export const useEnvCtxStore = create<EnvCtxType>((set, get) => ({
  envCtx: [],
  setEnvCtx: (env) => {
    set(
      produce<EnvCtxType>((e) => {
        e.envCtx.push(env);
      }),
    );
  },
  getEnvCtx: () => {
    return get().envCtx.at(-1) || 'none';
  },

  exitEnvCtx: (env) => {
    set((e) => {
      return {
        envCtx: e.envCtx.filter((a) => a !== env),
      };
    });
  },

  clearEnvCtx: () => {
    set({ envCtx: [] });
  },
}));
